import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../../../../../contexts/translation-context';
import { st, classes } from '../FileUpload.st.css';
import FileUploadIndicator from './FileUploadIndicator';
const File = _ref => {
  let {
    file,
    onDeleteClick,
    dataHook,
    focusFile = false,
    role,
    deleteButtonRef: deleteButtonRefFromProps,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const localDeleteButtonRef = useRef(null);
  const deleteButtonRef = deleteButtonRefFromProps || localDeleteButtonRef;
  useEffect(() => {
    if (focusFile) {
      var _deleteButtonRef$curr;
      deleteButtonRef == null || (_deleteButtonRef$curr = deleteButtonRef.current) == null || _deleteButtonRef$curr.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteButtonRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.fileContainer, {
      error: file.state === 'error'
    }),
    "aria-describedby": rest['aria-describedby'],
    "aria-label": file.file.name,
    role: role
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classes.file,
    title: file.file.name
  }, file.file.name), /*#__PURE__*/React.createElement("div", {
    className: classes.fileUploadIndicator
  }, /*#__PURE__*/React.createElement(FileUploadIndicator, {
    deleteButtonRef: deleteButtonRef,
    state: file.state,
    onDeleteClick: onDeleteClick,
    "aria-label": t('file-upload.delete-file.aria-label')
  })));
};
export default File;
//# sourceMappingURL=File.js.map